import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "right_cont" }
const _hoisted_2 = { class: "t6_title_h1" }
const _hoisted_3 = { class: "t2_sjzixun" }
const _hoisted_4 = { class: "t2_sjzixun_img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "t2_sjzixun_info" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "t2_sjzixun" }
const _hoisted_9 = { class: "t2_sjzixun_img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "t2_sjzixun_info" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text_list" }
const _hoisted_14 = ["onClick"]

import { getNewsContentList } from '@/config/request';
import { reactive, ref, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    typeName:String as any
},
  setup(__props) {

const store = useStore()
const router = useRouter()
const props = __props
const { typeName } = toRefs(props)
if(!typeName.value){
    typeName.value = '涉税咨询'
}
const name = ref(typeName.value)

const data = reactive({
    name: '最新税收',
    newsTypeId: '',
    newsList: [] as any,
    list1:[
        {
            name:'潘利',
            introduce:'注册会计师、中国注册会计师资深会员、河南省注册会计师协会理事、 河南大梁会计师事务所（普通合伙） 所长，从事财务工作30年，撰写 了理论文章四篇、重要调查报告二篇、业务工作总结八篇。擅长纳税筹 划、涉税咨询服务、规避企业税收风险、土地增值税清算、所得税汇算 清缴、进出口税务政策、企业税前弥补亏损鉴证，企业财产损失鉴证、 企业税收优惠及减免政策、税收征收管理咨询服务。',
            phone:'0371-22732190',
            qq:'3197474932',
            photo: 'panli.jpg',
        },
        {
            name:'刘研宏',
            introduce:'河南天鑫会计师事务所主任会计师、所长，为多家单位长期担任财务顾问，专业擅长为顾客提供涉税鉴证业务、税务咨询类业务、税务代理类业务、国际涉税业务等。',
            phone:'0371-22732187',
            qq:'3145290346',
            photo: 'liuhongyan.jpg',
        },
        {
            name:'仝明',
            introduce:'河南金皓翰税务师事务所有限公司所长，熟悉税务机关对社会公开的 涉税信息资料和相关税收法律规定，能够结合委托项目的具体情况， 作出相应的讲解、解答或策划方案。主要从事税收筹划、税务咨询、 提供土地增值税清算、所得税汇算清缴、财产损失鉴证报告等涉税服务。',
            phone:'0371-22733886',
            qq:'2947014794',
            photo: 'tongming.jpg',
        },
        {
            name:'乔利亚',
            introduce:'开封嘉诚税务师事务所（特殊普通合伙）所长，对税收体制 改革与企业自主创新问题，中国财税体制改革的方向深有研 究。特长协助纳税人申请减税、免税、其他退税等事项，帮 助企业解决纳税问题，出具涉税鉴证报告。',
            phone:'0371-22732172',
            qq:'2431688719',
            photo: 'qiaoliya.jpg',
        },
        {
            name:'冀文焕',
            introduce:'开封市华文会计师事务所有限公司创办人、开封国家众创空间优秀青年企业家、 中小企业财税专家。2016年创立华文会计师事务所，至今为中小型企业税收优 惠、税务筹划、高新技术企业认定、进出口税务等服务近三千家。提供小微企业 税务服务政策、高新企业认定及优惠政策、进出口贸易税务筹划、建筑行业税务 筹划、企业所得税汇算清缴、企业清算、审计等咨询服务。',
            phone:'0371-22732191',
            qq:'2132246015',
            photo: 'jiwenhuan.jpg',
        },
        {
            name:'孙兵杰',
            introduce:'河南盛誉财务有限公司总经理、中国会计服务联盟副主席、河 南省财务服务行业协会常务副会长、开封市财务服务行业协会 会长、市工商联执委、市青联委员，被省财务协会评为2018 年度“十大行业领军人物”。擅长税收筹划、税务咨询、提供土 地增值税清算、所得税汇算清缴、财产损失鉴证报告等涉税服务。',
            phone:'0371-22733887',
            qq:'3270199411',
            photo: 'sunbingjie.jpg',
        }
    ],
    list2:[
        {
            name:'郭洪荣',
            introduce:'中央财经大学税收教育研究所副所长、中国社会科学院税务硕士教育中心硕士导师、中税协准则委员会副主任、洪海明珠（北京）税收应用科学技术中心主任。 创编《中国纳税实务全书》，主编并出版图书40余册。中国税务服务联盟税务处理软件总体设计，税务服务规范研发创制， 税务处理风险评估产品研发与应用，税法应用数据库创制，承办税务行政复议诉讼案件40余件。',
            phone:'',
            qq:'1477046281',
            photo: 'guo.jpg',
        },
        {
            name:'河南大学经济学院',
            introduce:'河南大学经济学院是河南大学最早设立的学科之一， 1927年，河南大学前身国立 第五中山大学就设立了经济系，著名的经济学家和社会活动家罗章龙、王毅斋、关 梦觉等曾在此任教。经济学院下设经济系、贸易系、经济研究所、财政金融研究所、 改革与发展研究中心。拥有理论经济学、应用经济学和统计学3个省级一级重点学科， 理论经济学、应用经济学和统计学3个博士后流动站；成立了新型城镇化与中原经济 区建设河南省协同创新中心、中原发展研究院、“新三板”研究院等研究机构，为政 府和企业提供智力支持。',
            phone:'',
            qq:'3207308497',
            photo: 'xueyuan.jpg',
        },
    ]
})

const getNewsList = async() => {
    const newsTypeList = await store.dispatch('getNewsType') as any
    newsTypeList.forEach((res:any)=>{
        if(res.themeName === '涉税咨询'){
            data.newsTypeId = res.id
        }
    })
    const param = {
        themeId: data.newsTypeId,
        typeName: data.name
    }
    const res = await getNewsContentList(param) as any
    if(res.result?.records.length > 6){
        data.newsList = res.result?.records.slice(0,6)
    }else{
        data.newsList = res.result?.records
    }
}

const showDetail = (item:any) => {
    router.push({
        path: '/news-detail',
        query:{
            id: item.id
        }
    })
}
const toNewsList = () => {
    let param = {
        themeId: data.newsTypeId,
        typeName: data.name
    }
    router.push({
        path: '/news-list',
        query: param
    })
}
const linkQQ = (qq:string) => {
    let link = `tencent://message/?uin=${qq}&Site=员&Menu=yes`
    location.href = link
}
getNewsList()   //  获取最新税收新闻

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_unref(typeName)) + " ", 1),
      (_unref(typeName) === '最新税收')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "more",
            onClick: toNewsList
          }, "查看更多"))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.list1, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "t2_sjzixun_list",
          key: i
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: 'images/tex-center/'+item.photo
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h1", null, [
              _cache[0] || (_cache[0] = _createStaticVNode("<span data-v-8bbbdff4><img src=\"images/strat1.png\" data-v-8bbbdff4><img src=\"images/strat1.png\" data-v-8bbbdff4><img src=\"images/strat1.png\" data-v-8bbbdff4><img src=\"images/strat1.png\" data-v-8bbbdff4><img src=\"images/strat1.png\" data-v-8bbbdff4></span>", 1)),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ]),
            _createElementVNode("p", null, _toDisplayString(item.introduce), 1),
            _createElementVNode("p", null, [
              _createElementVNode("small", null, "联系电话：" + _toDisplayString(item.phone), 1),
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (linkQQ(item.qq))
                }, "我要咨询", 8, _hoisted_7)
              ])
            ])
          ])
        ]))
      }), 128))
    ], 512), [
      [_vShow, _unref(typeName) === '涉税咨询']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.list2, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "t2_sjzixun_list",
          key: i
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: 'images/tex-center/'+item.photo
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h1", null, [
              _cache[1] || (_cache[1] = _createStaticVNode("<span data-v-8bbbdff4><img src=\"images/strat1.png\" data-v-8bbbdff4><img src=\"images/strat1.png\" data-v-8bbbdff4><img src=\"images/strat1.png\" data-v-8bbbdff4><img src=\"images/strat1.png\" data-v-8bbbdff4><img src=\"images/strat1.png\" data-v-8bbbdff4></span>", 1)),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ]),
            _createElementVNode("p", null, _toDisplayString(item.introduce), 1),
            _createElementVNode("p", null, [
              _createElementVNode("small", null, "联系电话：" + _toDisplayString(item.phone), 1),
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (linkQQ(item.qq))
                }, "我要咨询", 8, _hoisted_12)
              ])
            ])
          ])
        ]))
      }), 128))
    ], 512), [
      [_vShow, _unref(typeName) === '特聘专家']
    ]),
    _withDirectives(_createElementVNode("ul", _hoisted_13, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.newsList, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          onClick: ($event: any) => (showDetail(item))
        }, [
          _createElementVNode("a", null, _toDisplayString(item.title), 1),
          _createElementVNode("span", null, _toDisplayString(item.releaseDate), 1)
        ], 8, _hoisted_14))
      }), 128))
    ], 512), [
      [_vShow, _unref(typeName) === '最新税收']
    ])
  ]))
}
}

})